<template>
  <span
    role="button"
    class="back-btn-wrapper btn-inline text-medium flex-center pointer"
    @click="$emit('back')"
  >
    <i class="arrow-left-icon"></i>
  </span>
</template>

<script>
/**
 * This exposes a button. Currently, it is being used for back functionality
 */
export default {
  name: 'BackButton'
}
</script>

<style lang="scss" scoped>
@import '~@/styles/styleConfigurations';

.back-btn-wrapper {
  font-weight: normal;
  cursor: pointer;
  padding-left: 16px;
  background-color: $brandSecondary;
}
</style>
